import { useTranslation } from 'react-i18next';

const PassengerInformation = ({ authDetailBooking, typo12 }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  return (
    <div className="tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:lg:px-7 tw:py-[30px]">
      <div className="tw:font-hanken-grotesk tw:pb-6 tw:text-[15px] tw:font-bold tw:leading-[22px] tw:text-[#282828] tw:px-5 tw:lg:px-0">
        {t('bookingDetail.passengerInformation.title')}
      </div>
      <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
      <div className="tw:flex tw:flex-wrap tw:gap-[25px] tw:pt-6 tw:px-5 tw:lg:px-0">
        <div className="tw:flex tw:w-[170px] tw:flex-col tw:gap-[3px]">
          <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>
            {t('bookingDetail.passengerInformation.passengerName')}
          </span>
          <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
            {authDetailBooking?.pickupSignHonorific} {authDetailBooking?.passengerName}
          </div>
        </div>
        <div className="tw:flex tw:w-[170px] tw:flex-col tw:gap-[3px]">
          <span className={`tw:font-hanken-grotesk tw:text-[#A7A7A7] ${typo12}`}>
            {t('bookingDetail.passengerInformation.passengerPhoneNumber')}
          </span>
          <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:!mb-0 tw:leading-[22px] tw:text-[#282828]">
            {`(${authDetailBooking?.passengerPrefixNumber}) ${authDetailBooking?.passengerPhoneNumber}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassengerInformation;
